import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, DatePicker, Button, Popconfirm, message } from 'antd';
import UpdateEnrollment from './UpdateEnrollment';
import API_URL from '../../../common/url';
import $ from '../../../common/AjaxRequest';
import SideNav from '../SideNav';
import moment from 'moment';

const monthFormat = 'YYYY-MM';
const dateFormat = 'YYYY-MM-DD';
const { MonthPicker } = DatePicker;

class Filter extends Component {
    state = {
        loading: false,
        searchParams: {},
    }

    search = () => {
        const { searchParams } = this.state;
        this.props.search(searchParams);
    }

    updateEnrollment = () => {
        this.props.canEditByInvStatus(() => this.props.updateEnrollment());
    }

    back = () => {
        history.go(-1);
    }

    onStartChange = (date, dateString) => {
        const { searchParams } = this.state;
        if (date == null){
            searchParams.startDate = null;
            searchParams.endDate = null;
            this.setState({ searchParams });
            return;
        }
        let dTemp = moment(dateString),
            dTemp1 = moment(dateString);
        searchParams.startDate = dTemp.startOf('week').format(dateFormat);
        searchParams.endDate = dTemp1.endOf('week').format(dateFormat);
        this.setState({ searchParams });
    }

    onMonthChange = (date, dateString, field) => {
        const { searchParams } = this.state;
        searchParams[field] = dateString;
        this.setState({ searchParams });
    }

    render() {
        const { type } = this.props;
        const { curRole } = sessionStorage;
        const isPAPM = curRole == 'PA' || curRole == 'PM';
        const { searchParams: { startDate, endDate, startMonth, endMonth } } = this.state;
        const newStartDate = startDate ? moment(startDate) : null;
        const newEndDate = endDate ? moment(endDate) : null;
        const newStartMonth = startMonth ? moment(startMonth) : null;
        const newEndMonth = endMonth ? moment(endMonth) : null;
        return (
            <div className="filter-bar bar2">
                {
                    type == 'WEEK'
                    ?
                        <div className="form-item month-range-picker">
                            <label className="ui-label">时间</label>
                            <DatePicker
                                className="begin"
                                format={dateFormat}
                                allowClear={true}
                                placeholder="开始日期"
                                value={newStartDate}
                                onChange={this.onStartChange}
                            />
                            <DatePicker
                                className="end"
                                format={dateFormat}
                                allowClear={true}
                                placeholder="结束日期"
                                value={newEndDate}
                                onChange={this.onStartChange}
                            />
                        </div>
                    :
                        <div>
                            <div className="form-item">
                            <label className="ui-label">时间</label>
                                <MonthPicker
                                    format={monthFormat}
                                    allowClear={true}
                                    placeholder="选择月份"
                                    value={newStartMonth}
                                    onChange={(date, dateString) => this.onMonthChange(date, dateString, 'startMonth')}
                                />
                            </div>
                            <div className="form-item">
                                <label className="ui-label">至</label>
                                <MonthPicker
                                    format={monthFormat}
                                    allowClear={true}
                                    placeholder="选择月份"
                                    value={newEndMonth}
                                    onChange={(date, dateString) => this.onMonthChange(date, dateString, 'endMonth')}
                                />
                            </div>
                        </div>
                }
                <div className="form-item">
                    <Button type="primary" onClick={this.back} style={{ background: '#62cf96', border: '1px solid #00a854' }}>返回</Button>
                    { isPAPM && <Button type="primary" onClick={this.updateEnrollment}>添加</Button> }
                    <Button type="primary" onClick={this.search}>搜索</Button>
                </div>
            </div>
        )
    }
}

class Enrollment extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {},
        pagination: {
            current: 1,
            pageSize: 10,
        }
    }

    componentDidMount() {
        const { saveParams = {} } = this.props;
        if (Object.keys(saveParams).length) {
            this.loadData();
        } else {
            location.href = './#/competeCompany/performance';
        }
        this.queryInvestigationStageByInvId();
    }

    loadData = () => {
        const { saveParams = {} } = this.props;
        const { competingCompanyManifestationId } = saveParams;
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.queryCompetingCompanyGroup,
            data: {
                ...sortParams,
                ...searchParams,
                offset: current,
                limit: pageSize,
                competingCompanyManifestationId,
            },
            dataType: 'json',
            doneResult: res => {
                const { totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    data: res.datas,
                    loading: false,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (params = {}) => {
        this.setState((prevState) => ({
            searchParams: {...params},
            pagination: {
                ...prevState,
                current: 1,
            }
        }), () => {
            this.loadData();
        });
    }

    handleDelete = (competingCompanyGroupId) => {
        const { saveParams = {} } = this.props;
        const { competingCompanyManifestationId } = saveParams;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.competeCompany.deleteCompetingCompanyGroup,
            data: {
                competingCompanyGroupId,
                competingCompanyManifestationId,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
        };
        $.sendRequest(options);
    }

    queryInvestigationStageByInvId = () => {
        const { invId: investigationId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                this.setState({
                    invStageList: data,
                });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (callback) => {
        const { invStageList: data = [] } = this.state;
        const canEdit = !(data || []).some(i => {
            if (i.operation === 'INVESTIGATION_LEVEL_LOWEST') {
                message.error('项目到达“项目终止”阶段，不可调整项目相关数据！');
                return true;
            } else if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                message.error('项目到达“项目关闭”阶段，不可调整项目相关数据！');
                return true;
            } else if(i.operation === 'TERMINATED_BEFORE_CONTRACT'){
                message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                return true;
            }
            return false;
        });
        if (canEdit) {
            callback();
        }
    }

    getRender = (text, record) => {
        if (record.dateStr == '合计') {
            return <strong>{text}</strong>;
        } else {
            return text;
        }
    }

    getColumns = (type) => {
        const columns = [{
            title: '时间',
            dataIndex: 'dateStr',
            sorter: true,
            render: this.getRender,
        }, {
            title: `本${type === 'WEEK' ? '周' : '月'}筛选数量`,
            dataIndex: 'filterOutNumber',
            render: this.getRender,
        }, {
            title: `本${type === 'WEEK' ? '周' : '月'}入组数量`,
            dataIndex: 'groupNumber',
            render: this.getRender,
        }];
        const { curRole } = sessionStorage;
        if (curRole == 'PA' || curRole == 'PM') {
            columns.push({
                title: '操作',
                dataIndex: 'operate',
                render: (text, record) => {
                    const { dateStr, competingCompanyGroupId } = record;
                    if (dateStr != '合计') {
                        return (
                            <span>
                                <a onClick={() => this.canEditByInvStatus(() => this.updateEnrollment(record))}>修改</a>
                                <span className="ant-divider" />
                                <Popconfirm title='确认要删除吗?' onConfirm={() => this.canEditByInvStatus(() => this.handleDelete(competingCompanyGroupId))} okText="确定" cancelText="取消">
                                    <a>删除</a>
                                </Popconfirm>
                            </span>
                        )
                    }
                }
            });
        }
        return columns;
    }

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({
            ...item,
        }));
        return dataSource;
    }

    handleTableChange = (pagination, filters, sorter) => {
        const { sortParams } = this.state;
        sortParams.direction = sorter.order === 'descend' ? 'DESC' : 'ASC';
        sortParams.sort = sorter.field ;
        this.setState({
            pagination,
            sortParams,
        }, () => {
            this.loadData();
        });
    }

    updateEnrollment = (record) => {
        this.updateEnrollmentRef.show(record);
    }

    render() {
        const { loading, pagination } = this.state;
        const { saveParams = {} } = this.props;
        const { type, companyName, hospitalName, departmentLocalName, competingCompanyManifestationId } = saveParams;
        return (
            <div className="content">
                <SideNav selectKey='performance' />
                <div className="main">
                    <div style={{ padding: '10px 20px 10px 4px' }}>
                        公司名称：{companyName}
                        <span className="ant-divider" />
                        医院名称：{hospitalName}
                        <span className="ant-divider" />
                        科室：{departmentLocalName}
                    </div>
                    <Filter
                        type={type}
                        search={this.search}
                        loadData={this.loadData}
                        updateEnrollment={this.updateEnrollment}
                        canEditByInvStatus={this.canEditByInvStatus}
                    />
                    <Table
                        bordered
                        loading={loading}
                        rowKey={row => row.key}
                        pagination={pagination}
                        columns={this.getColumns(type)}
                        dataSource={this.getDataSource()}
                        onChange={this.handleTableChange}
                    />
                    <UpdateEnrollment
                        type={type}
                        loadData={this.loadData}
                        ref={el => this.updateEnrollmentRef = el}
                        competingCompanyManifestationId={competingCompanyManifestationId}
                    />
                </div>           
            </div>
        )
    }
}

const mapSateToProps = (state) => ({
    saveParams: state.competeCompanyState.params || {},
});

export default connect(mapSateToProps, null)(Enrollment);


// WEBPACK FOOTER //
// ./src/components/competeCompany/Enrollment/index.js